import { KeyboardCode } from '@dnd-kit/core';

import { PageData } from './PagesManager';

export interface PagesProps {
  addNewPage: (props: any) => void;
  duplicatePage: (item: any) => void;
  removePage: (item: any) => void;
  items: PageData[];
  activationConstraint?: {
    distance: number;
  };
  handleClick?: (item: PageData) => void;
  handlePageMove?: (pageIds: string[]) => void;
  isOpen?: boolean;
  activePage: number;
  restrictions?: {
    addPage?: boolean;
    changePageOrder?: boolean;
    removePage?: boolean;
    duplicatePage?: boolean;
  };
}

export const directions: string[] = [
  KeyboardCode.Down,
  KeyboardCode.Right,
  KeyboardCode.Up,
  KeyboardCode.Left,
];
export const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space],
};
